<template>
  <div class="flex-col align-center">
    <span class="title">配置优惠券活动</span>

    <el-form class="formStyle" ref="form" :model="activity" :rules="rules" label-width="80px">
      <el-form-item label="活动名称" prop="activityName">
        <el-input v-model="activity.activityName" placeholder="请填写活动名称"></el-input>
      </el-form-item>
      <el-form-item label="优惠券名" prop="couponName">
        <el-input v-model="activity.couponName" placeholder="请填写优惠券名"></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="beginTime">
        <div class="flex-row align-center">
          <div class="timeSelect" @click="selectBeginTime">{{ beginTime }}</div>
          <el-input class="timeInput" v-model="beginTimeHours" :maxlength="2" type="number" placeholder="时"></el-input>
          <span class="breakawayPoint">:</span>
          <el-input class="timeInput" v-model="beginTimeMinutes" :maxlength="2" type="number"
                    placeholder="分"></el-input>
          <span class="breakawayPoint">:</span>
          <el-input class="timeInput" v-model="beginTimeSeconds" :maxlength="2" type="number"
                    placeholder="秒"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <div class="flex-row align-center justify-between">
          <div class="timeSelect" @click="selectEndTime">{{ endTime }}</div>
          <el-input class="timeInput" v-model="endTimeHours" :maxlength="2" type="number" placeholder="时"></el-input>
          <span class="breakawayPoint">:</span>
          <el-input class="timeInput" v-model="endTimeMinutes" :maxlength="2" type="number" placeholder="分"></el-input>
          <span class="breakawayPoint">:</span>
          <el-input class="timeInput" v-model="endTimeSeconds" :maxlength="2" type="number" placeholder="秒"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="相关服务" prop="product">
        <div class="customSelect" @click="selectProduct">{{ product.label }}</div>
      </el-form-item>
      <el-form-item label="选择门店" prop="posList">
        <multiple-choice-list
          :list="posList"
          :list-all-select="posAllSelect"
          :checkedList="checkedList"
          :handleListAllSelected="posListAllSelected"
          :handle-list-selected="posSelected"
        ></multiple-choice-list>
      </el-form-item>
      <el-form-item label="活动规则" style="margin-bottom: 8px">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入活动规则"
          v-model="activity.activityDescribe">
        </el-input>
      </el-form-item>
      <div class="counter flex-row align-center justify-start">
        <div class="formLabel flex-row">发券数量</div>
        <div class="value_row flex-row justify-end align-center">
          <el-input-number v-model="activity.maxIssuanceNum" :min="1" :max="1000000"></el-input-number>
          <span class="unit">次</span>
        </div>
      </div>
      <div class="counter flex-row align-center justify-start">
        <div class="formLabel flex-row link" @click="couponValidDayDailog">优惠券有效期</div>
        <div class="value_row flex-row justify-end align-center">
          <el-input-number v-model="activity.couponValidDay" :min="1" :max="1000000"></el-input-number>
          <span class="unit">天</span>
        </div>
      </div>
      <div class="counter flex-row align-center justify-start">
        <div class="formLabel flex-row">单人最大领取数</div>
        <div class="value_row flex-row justify-end align-center">
          <el-input-number v-model="activity.userMaxReceiveNum" :min="1" :max="1000000"></el-input-number>
          <span class="unit">张</span>
        </div>
      </div>
      <div class="counter flex-row align-center justify-start">
        <div class="formLabel flex-row">一人一天最大领取数</div>
        <div class="value_row flex-row justify-end align-center">
          <el-input-number v-model="activity.userDailyMaxReceiveNum" :min="1" :max="1000000"></el-input-number>
          <span class="unit">张</span>
        </div>
      </div>
    </el-form>

    <div class="submit_button_container">
      <el-button class="sureButton" type="primary" @click="submitCouponActivity">确认</el-button>
    </div>
  </div>
</template>

<script>
import MultipleChoiceList from "../../components/multipleChoiceList.vue";
import {createCouponActivity, queryCouponActivityInfo, updateCouponActivity} from "../../api/coupon";
import {queryAllProduct, queryGlobalProduct, queryPosListByCouponActivity} from "../../graphql/api";
import moment from "moment";

export default {
  name: "coupon_activity_mgr",
  components: {MultipleChoiceList},
  data() {
    const generateData = _ => {
      const data = [];
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `备选项 ${i}`,
          disabled: i % 4 === 0
        });
      }
      return data;
    };
    return {

      data: generateData(),
      value: [1, 4],

      beginTime: "选择开始时间",
      endTime: "选择结束时间",
      product: {
        label: "请选择相关服务",
        value: null
      },

      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur'},
        ],
        couponName: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur'},
        ],
        beginTime: [
          { required: true, message: '请输入活动开始日期', trigger: 'blur'},
        ],
        endTime: [
          { required: true, message: '请输入活动结束时间', trigger: 'blur'},
        ],
        product: [
          { required: true, message: '请选择优惠券相关服务', trigger: 'blur'},
        ],
        posList: [
          { required: true, message: '请选择至少一个支持优惠券门店', trigger: 'blur'},
        ]
      },

      activity: {
        activityName: "",
        posIdListStr: "",
        couponName: "",
        partnerId: sessionStorage.getItem('partnerid'),
        activityDescribe: "略",
        couponValidDay: 1,
        maxIssuanceNum: 1,
        userMaxReceiveNum: 1,
        userDailyMaxReceiveNum: 1,
        state: 1
      },

      beginTimeHours: "00",
      beginTimeMinutes: "00",
      beginTimeSeconds: "00",
      endTimeHours: "23",
      endTimeMinutes: "59",
      endTimeSeconds: "59",

      productList: [],

      posList: [],
      allPosList: [],

      posAllSelect: {
        label: "选择支持优惠券门店",
        isIndeterminate: false,
        state: false
      },

      checkedList: []
    }
  },
  mounted() {
    this.queryAllProduct();
    this.queryPosByPartner();
  },
  methods: {
    // 查询对应的优惠券活动
    queryCouponActivity(id) {
      queryCouponActivityInfo({
        activityId: id
      }).then(res => {
        console.log('查询优惠券活动', res);
        let data = res.data.queryAllCouponActivity[0];
        this.dataHandle(data);
      }).catch(error => {
        console.log('查询优惠券活动异常', error);
      })
    },

    dataHandle(data) {
      this.activity = {
        activityName: data.activityName,
        posIdListStr: data.posIdListStr,
        couponName: data.couponName,
        partnerId: data.partnerId,
        activityDescribe: data.activityDescribe,
        couponValidDay: data.couponValidDay,
        maxIssuanceNum: data.maxIssuanceNum,
        userMaxReceiveNum: data.userMaxReceiveNum,
        userDailyMaxReceiveNum: data.userDailyMaxReceiveNum,
        state: data.state
      }

      let beginTime = data.beginTime.split(" ");
      this.beginTime = beginTime[0];
      let beginTimeNum = beginTime[1].split(":");
      this.beginTimeHours = beginTimeNum[0];
      this.beginTimeMinutes = beginTimeNum[1];
      this.beginTimeSeconds = beginTimeNum[2];

      let endTime = data.endTime.split(" ");
      this.endTime = endTime[0];
      let endTimeNum = endTime[1].split(":");
      this.endTimeHours = endTimeNum[0];
      this.endTimeMinutes = endTimeNum[1];
      this.endTimeSeconds = endTimeNum[2];

      // this.productList.find(item => item);
      for(const item of this.productList) {
        if(item.value === data.availableProductType) {
          this.product = item;
          this.changePosListBySelectProduct(item)
        }
      }

      let tempPosList = data.posIdListStr.split(',');
      console.log('门店数组为', tempPosList);
      tempPosList.forEach(tempItem => {
        const realTtem = this.posList.find(b => b.value === tempItem);
        if(realTtem) {
          realTtem.state = true;
        }
      })
      this.posAllSelect.state = this.posList.every(pos => pos.state === true);


      this.id = Number(data.id);
    },

    // 选择活动开始时间
    selectBeginTime() {
      let that = this;
      this.$weui.datePicker({
        start: new Date().getFullYear(),
        end: 2030,
        onChange: function (result) {
          console.log(result);
        },
        onConfirm: function (result) {
          console.log(result);

          let month = result[1].value;
					let day = result[2].value;

          // 如果月份小于10，则在前面添加"0"
          if (month < 10) {
            month = "0" + String(month);
          }
					if (day < 10) {
						day = "0" + String(day);
          }
          // 无论月份是否小于10，都执行相同的字符串拼接操作
          that.beginTime = `${result[0].value}-${month}-${day}`;

          console.log('this.beginTime', that.beginTime);
        },
        title: '请选择开始时间'
      })
    },

    // 选择活动结束时间
    selectEndTime() {
      let that = this;
      this.$weui.datePicker({
        start: new Date().getFullYear(),
        end: 2030,
        onConfirm: function (result) {
          console.log(result);
          let month = result[1].value;
					let day = result[2].value;
          // 如果月份小于10，则在前面添加"0"
          if (month < 10) {
            month = "0" + String(month);
          }
	        if (day < 10) {
		        day = "0" + String(day);
	        }
          // 无论月份是否小于10，都执行相同的字符串拼接操作
          that.endTime = `${result[0].value}-${month}-${day}`
          console.log('this.endTime', that.endTime);
        },
        title: '请选择结束时间'
      })
    },

    // 选择相关服务
    selectProduct() {
      let that = this;
      this.$weui.picker(that.productList, {
        className: 'custom-classname',
        container: 'body',
        defaultValue: [3],
        onConfirm: function (result) {
          console.log(result)
          that.product = result[0];
          that.changePosListBySelectProduct(that.product);
        },
      })
    },

    changePosListBySelectProduct(product) {
      console.log('选择的服务是：', product);
      let existProductPosList = [];
      for(const item of this.allPosList) {
        for(const p_item of item.product){
          if(p_item.product.productType === product.value) {
            existProductPosList.push(item)
          }
        }
      }
      this.posList = existProductPosList;
    },

    // 查询所有产品
    queryAllProduct() {
      this.queryGlobalProduct();
      this.queryPartnerAllProduct();
    },

    queryGlobalProduct() {
      let params = {
        page: 1,
      };
      queryGlobalProduct(params).then(res => {
        console.log('查询全局产品', res);
        for (const item of res.data.findGlobalProduct) {
          this.productList.push({
            label: item.name,
            value: item.productType
          });
        }
      }).catch(error => {
        alert(`查询全局产品异常：${error}`)
      })
    },

    // 查询商户所有产品
    queryPartnerAllProduct() {
      let params = {
        partnerId: sessionStorage.getItem('partnerid'),
        page: 1
      }
      queryAllProduct(params).then(res => {
        console.log('查询商户所有产品', res);
        if (res.data.queryProduct) {
          for (const item of res.data.queryProduct) {
            this.productList.push({
              label: item.name,
              value: item.productType
            })
          }
        }
        console.log('this.productList:', this.productList);
      }).catch(error => {
        alert(`查询商户所有产品异常：${error}`)
      })
    },

    // 查询门店
    queryPosByPartner() {
      queryPosListByCouponActivity({
        partnerId: sessionStorage.getItem('partnerid'),
      }).then(res => {
        let data = res.data.queryPosInfo;
        console.log('查询到的门店', data);
        for (let item of data) {
          if (item.lstProduct) {
            this.posList.push({
              label: item.pos.name,
              value: item.pos.posId,
              product: item.lstProduct,
              state: false,
            })

            this.allPosList.push({
              label: item.pos.name,
              value: item.pos.posId,
              product: item.lstProduct,
              state: false,
            })
          }
        }

        console.log('可用的门店', this.allPosList);

        // 在查询到门店后再执行修改优惠券活动是的数据映射
        if(this.$route.query.id) {
          this.queryCouponActivity(this.$route.query.id)
        }
      }).catch(error => {
        alert(`查询门店异常：${error}`);
      })
    },

    // 提交优惠券活动
    submitCouponActivity() {
      console.log('提交优惠券活动', this.activity);

      if (!this.activity.activityName) {
        alert('请输入活动名称！')
      } else if (!this.activity.couponName) {
        alert('请输入优惠券名称!')
      } else if (this.beginTime === "选择开始时间") {
        alert('请选择活动开始时间!')
      } else if (this.endTime === "选择结束时间") {
        alert('请选择活动结束时间!')
      } else if (!this.product.value) {
        alert('请选择优惠券的相关服务!')
      } else if (this.allPosStateIsFalse(this.posList)) {
        alert('请选择至少一个优惠券可用门店!')
      } else {
        let params = this.activity;
        params.createTime = moment().format('YYYY-MM-DD HH:mm:ss');
        params.beginTime = `${this.beginTime} ${this.beginTimeHours}:${this.beginTimeMinutes}:${this.beginTimeSeconds}`;
        params.endTime = `${this.endTime} ${this.endTimeHours}:${this.endTimeMinutes}:${this.endTimeSeconds}`;

        // 每次扫码领取数量
        params.perIssuanceNum = 1

        params.posIdListStr = ""

        for (const item of this.posList) {
          if (item.state) {
            params.posIdListStr = params.posIdListStr + item.value + ","
          }
        }

        params.posIdListStr = params.posIdListStr.substring(0, params.posIdListStr.length - 1)
        params.availableProductType = this.product.value;

        if(!this.$route.query.id) {
          this.addCouponActivity(params);
        } else {
          this.editCouponActivity(params);
        }

      }
    },

    // 新增优惠券活动
    addCouponActivity(params) {
      createCouponActivity(params).then(res => {
        console.log('新增优惠券回调响应', res);
        if (res.data.createCouponActivity) {
          alert(`${res.data.createCouponActivity.note}`)
          if (res.data.createCouponActivity.code === 1) {
            this.$router.push('/coupon_activity_list')
          }
        }
      }).catch(error => {
        console.log('创建优惠券活动异常', error);
      })
    },

    // 修改优惠券活动
    editCouponActivity(params) {
      params.id = this.id
      updateCouponActivity(params).then(res =>{
        console.log('修改优惠券回调响应', res);
        if (res.data.updateCouponActivity) {
          alert(`${res.data.updateCouponActivity.note}`)
          if (res.data.updateCouponActivity.code === 1) {
            this.$router.push('/coupon_activity_list')
          }
        }
      })
    },



    allPosStateIsFalse(arr) {
      return arr.every(obj => obj.state === false);
    },

    // 全选
    posListAllSelected() {
      this.posAllSelect.isIndeterminate = false;
      if (this.posAllSelect.state) {
        for (const item of this.posList) {
          item.state = true;
          this.checkedList.push(item);
        }
      } else {
        this.checkedList = [];
        for (const item of this.posList) {
          item.state = false;
        }
      }

      console.log('全选后门店列表为', this.posList);
    },

    // 单选
    posSelected(item) {
      console.log('item', item);
      if (item.state) {
        this.checkedList.push(item)
      } else {
        console.log('移除指定元素');
        this.checkedList = this.checkedList.filter(pos => pos !== item);
      }

      this.posAllSelect.isIndeterminate = !this.posList.every(pos => pos.state === true);

      if (this.checkedList.length === 0) {
        this.posAllSelect.isIndeterminate = false;
      }

      this.posAllSelect.state = this.posList.every(pos => pos.state === true);

      console.log('单选后门店列表为', this.posList);
    },

    couponValidDayDailog() {
      this.$alert('优惠券的有效期以领取优惠券时为开始时间，不受优惠券活动时间的影响！', '有效期')
    },
  }
}
</script>

<style lang="scss" src="../../css/coupon_activity_mgr.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/coupon_activity_mgr.vue